import { clsx } from 'clsx';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import type { ReactNode } from 'react';
import { SyntheticEvent, useRef } from 'react';
import { Icon } from '../Icon/Icon';
import { MenuItem } from '../Menu/Menu';
import s from './DropdownMenu.module.scss';

interface DropdownMenuProps {
    disabled?: boolean;
    actions?: MenuItem[];
    iconSize?: 'small' | 'normal' | 'large';
    dropdownIconFactory?: (
        onClick: (event: SyntheticEvent) => void,
    ) => ReactNode;
    contrast?: boolean;
    'data-testid'?: string;
}

export function DropdownMenu({
    disabled,
    actions,
    dropdownIconFactory,
    iconSize,
    contrast,
    'data-testid': dataTestId,
}: DropdownMenuProps) {
    const menu = useRef<Menu>(null);

    const onClick = (event: SyntheticEvent) => {
        menu.current?.toggle(event);
    };

    const className = clsx(s.actionButton, contrast ? s.contrast : null);
    const menuClassName = clsx(contrast ? s.contrast : null);
    return actions && actions.length > 0 ? (
        <>
            {dropdownIconFactory ? (
                dropdownIconFactory(onClick)
            ) : (
                <Button
                    type="button"
                    onClick={onClick}
                    text
                    disabled={disabled}
                    className={className}
                    data-testid={dataTestId}
                    icon={<Icon name="more_vert" fontSize={iconSize} />}
                />
            )}
            <Menu className={menuClassName} model={actions} popup ref={menu} />
        </>
    ) : null;
}
